/**
 * Format an IANA timezone identifier as a friendly city name.
 * "America/Los_Angeles" → "Los Angeles". Falls back to the original string when
 * the identifier doesn't have the expected `region/city` shape.
 */
export function getCityFromTimezone(timezone: string): string {
  const lastSegment = timezone.split("/").pop();
  if (!lastSegment) {
    return timezone;
  }
  return lastSegment.replace(/_/g, " ");
}
